import { BookingJourneyState } from "store/bookingJourney";
import { checkSkip } from "utils/helpers";
import { BookingJourneyStep, WizardStep } from "utils/types";


export const dateAndLocationWizardStep: WizardStep = {
  skip: (state: BookingJourneyState) => checkSkip(state.basket.products, BookingJourneyStep.DateAndLocation)
};
